import useMutateCheckUser from "@/pages/auth/login/hooks/useLogin";
import { phoneNumberValidation } from "@/utilities/validation";
import { Button, Stack, TextInput } from "@mantine/core";
import { useForm, yupResolver } from "@mantine/form";
import { useTranslation } from "react-i18next";
import PersianUtil from "@/services/persianUtiles/numberPersianUtiles";

import * as Yup from "yup";

const schema = Yup.object().shape({
  phoneNumber: Yup.string()
    .required("شماره تلفن را وارد نمایید")
    .matches(phoneNumberValidation, "شماره تلفن را به درستی وارد نمایید"),
});

const LoginWithPhoneNumber = () => {
  const { t } = useTranslation();
  const { isLoading, checkUser } = useMutateCheckUser();
  const form = useForm({
    initialValues: { phoneNumber: "" },
    validate: yupResolver(schema),
  });
  return (
    <Stack>
      <form
        onSubmit={form.onSubmit((values) => {
          checkUser({
            username: values?.phoneNumber,
          });
        })}
        className="w-100"
      >
        <Stack>
          <TextInput
            styles={{
              input: {
                direction: "ltr",
                textAlign: "left",
              },
              description: {
                fontSize: "0.8rem",
              },
              error: {
                fontSize: "0.8rem",
              },
            }}
            size="lg"
            type="tel"
            label="شماره موبایل"
            placeholder="0912 345 6789"
            autoComplete="tel-national"
            inputMode="tel"
            maxLength={11}
            value={form.values.phoneNumber}
            onChange={(e) => {
              const englishNumber = PersianUtil.currentNumberToEnglish(
                e.target.value
              );
              form.setFieldValue("phoneNumber", englishNumber);
            }}
            error={form.errors.phoneNumber}
          />
          <Button
            type="submit"
            size="lg"
            mt="md"
            className="w-100"
            loading={isLoading}
          >
            {t("login")}
          </Button>
        </Stack>
      </form>
    </Stack>
  );
};

export default LoginWithPhoneNumber;
